import React from 'react';
import { AppBar, makeStyles, Toolbar } from '@material-ui/core'
// import CustomizedMenus from '../../components/OpenMenu';



const useStyles = makeStyles(theme =>({
  root: {
    backgroundColor: '#f7f7f5'
  }
}));

const ClientHeader = (props) => {

  const classes = useStyles();
  const { children } = props;
  return (
    <AppBar position="static" className={classes.root}>
      <Toolbar>
        {children}        
      </Toolbar>
    </AppBar>
  );
};

export default ClientHeader;